import { isLoginSensitiveMoment, readPendingAttempt } from '@/logic/loginAttemptTracker';

/**
 * Decide whether to self-heal a "pinned" PWA: the server reports a newer build
 * than the running shell, the normal SW update path produced nothing (the host
 * can serve a stale sw.js after a deploy — observed on Lovable hosting), and we
 * haven't already tried for this exact target build (loop guard).
 */
export function shouldSelfHeal(
  serverBuild: string | null | undefined,
  runningBuild: string,
  alreadyAttemptedBuild: string | null,
  swUpdatePending: boolean,
): boolean {
  if (!serverBuild || serverBuild === runningBuild) return false;
  if (alreadyAttemptedBuild === serverBuild) return false;
  if (swUpdatePending) return false; // normal update path is working — let it
  return true;
}

/**
 * Applying a service-worker update reloads the page. NEVER do that while OAuth
 * tokens/errors are in the URL or a login attempt just started — that reload
 * was eating the OAuth callback on stale shells (user bounced back to the
 * login screen with no session). Kept free of `virtual:pwa-register` so any
 * component/test can import it.
 */
export function isUpdateSafeNow(): boolean {
  return !isLoginSensitiveMoment(window.location.href, readPendingAttempt());
}
